module.exports = __webpack_public_path__ + "static/media/logo.f2987075.png";